/*
eslint-disable react/prop-types
*/
import React, { useMemo } from 'react';
import styled, { withTheme } from 'styled-components/macro';
import { Article } from 'assets/lib';
import { useRouterContext } from 'hooks';
import { themeType } from 'types'
import PropTypes from 'prop-types'
import { useEditorContext } from 'context/EditorContext';

const ArticleModule = ({ data: dataProps, theme, ...props }) => {
  const {
    match: {
      params: { lang },
    },
  } = useRouterContext();
  const [{
    screen
  }] = useEditorContext();

  const data = useMemo(() => dataProps[lang] || dataProps, [dataProps, lang])
  const hasTitle = useMemo(() => !!(data && data.title && data.title.trim() !== ''), [data]);
  const hasTitleDefault = useMemo(() => !!(
    data
    && data.title
    && data.title.trim() !== ''
  ), [data])

  const articleProps = useMemo(() => ({
    hasTitleDefault,
    defaultContent: data,
    hasContent: true,
    hasTitle,
    gridClasses: screen === 'desktop' ? 'col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-12 offset-0' : 'col-12',
    activeColor: data.activeColor || theme.viewsColors.root,
    ...props
  }), [
    data,
    hasTitle,
    hasTitleDefault,
    theme.viewsColors.root,
    screen,
    props
  ])

  return (
    <Wrapper>
      <Article hasContent data={data} {...articleProps} />
    </Wrapper>
  )
}

ArticleModule.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string,
    activeColor: PropTypes.string,
    content: PropTypes.string
  }).isRequired,
  theme: themeType.isRequired,
};

ArticleModule.defaultProps = {
}

const Wrapper = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.greyLight};
`;

export default withTheme(ArticleModule);
